import React, { useRef, useState, useEffect } from 'react';
import { Image } from 'primereact/image';
import logoImg from '../../../../assets/images/logo.png'
import { Link, useNavigate } from "react-router-dom";
import { TieredMenu } from 'primereact/tieredmenu';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Amplify, Auth, DataStore, SortDirection } from 'aws-amplify';
import AWS from "aws-sdk";
import { reactLocalStorage } from 'reactjs-localstorage';
import NotificationComponent from "../../../notifications/notificationComponent";
import MailComponent from "../../../mails/mailComponent";
import { NotificationReadTable, NotificationTable, Schools } from "../../../../models";
import { Badge } from "primereact/badge";
import capitalizeFirst from "../../capitalizeFirst";
import moment from "moment/moment";
import AccountSettings from "../../AccountSettings";
import { 
  get_notifications,
  get_un_read_notifications,
  read_notifications
} from "../../../actions/notificationsGraphQLActions";


export default function Top({ ...pageProps }) {

  const loggedUserId = reactLocalStorage.get('loggedUserId');


  const menu = useRef(null);
  const notification = useRef(null);
  const mail = useRef(null);

  const [activate, setActivate] = useState("");

  const toggleActive = () => {
    setActivate(activate === "active" ? "" : "active");
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const unreadNotifications = useRef({ notifications: null, count: 0 });
  const unreadMails = useRef({ notifications: null, count: 0 });
  const [mailData, setMailData] = useState([]);

  const handleSidebarOpen = () => {
    setSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  const getNotification = async () => {

    const loggedUserId = reactLocalStorage.get("loggedUserId");
    try {
      const notifications = await get_notifications(loggedUserId, pageProps.appId ?? null, 'APP');
      notifications.sort((a, b) => b.created_at - a.created_at);
      const unReadNotifications = notifications.filter((notification) => notification.read_at === null);

      setNotificationData(notifications?.map((notification) => ({
        notificationTitle: notification?.subject,
        notificationMessage: notification?.message,
        notificationDate: notification?.created_at
      })));

      if (unReadNotifications?.length) {
        unreadNotifications.current = { notifications: unReadNotifications, count: unReadNotifications.length };
      } else {
        unreadNotifications.current = { notifications: [], count: 0 };
      }


      const emailNotifications = await get_notifications(loggedUserId, pageProps.appId ?? null, 'EMAIL');

      const unReadEmailNotifications = emailNotifications.filter((notification) => notification.read_at === null);

      setMailData(emailNotifications?.map((email) => ({
        mailTitle: email?.subject,
        mailMessage: email?.message,
        mailDate: email?.created_at
      })));

      if (unReadEmailNotifications) {
        unreadMails.current = { notifications: unReadEmailNotifications, count: unReadEmailNotifications.length };
      } else {
        unreadMails.current = { notifications: [], count: 0 };
      }
    } catch (e) {
      console.log("error in notification ", e);
    }
  }

  useEffect(() => {
    getNotification();
  }, []);


  useEffect(() => {
    const intervalId = setInterval(getNotification, 60000); // 30 seconds in milliseconds
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const openCloseMailPopup = async (type, e) => {
    if (type === 'EMAIL') {
      mail.current.toggle(e);
      if (unreadMails.current.count > 0) {
        await read_notifications(unreadMails.current.notifications);
        unreadMails.current = { notifications: null, count: 0 };
      }
    }
    if (type === 'APP') {
      notification.current.toggle(e);
      if (unreadNotifications.current.count > 0) {
        await read_notifications(unreadNotifications.current.notifications);
        unreadNotifications.current = { notifications: null, count: 0 };
      }
    }
  }
  return (<>
    {/* <div className={myinter.className}> */}
    <div className='fixed w-full z-20 header-wrap'>
      <div className='pl-[80px] xl:pl-[4.167vw]'>
        <div className='bg-white dashboardHeader shadow-[0px_4px_8px_-2px_rgba(16,24,40,0.1)] py-[0.500vw] relative z-20' >
          <div className='px-[15px] xl:px-[3.125vw] py-[12px] xl:py-[0.625vw]' data-aos="fade-down" data-aos-duration="700" data-aos-delay="500">
            <div className='flex items-center justify-between'>
              <div className='headerTitle'>Reports</div>
              <div className='flex items-center divide-x divide-[#E0E0E0] gap-x-[20px] lg:gap-x-[40px] xl:gap-x-[2.083vw]'>
                <div className='space-x-[20px] lg:space-x-[40px] xl:space-x-[2.083vw] relative'>
                  {/* <Link to={""} onClick={(e) => openCloseMailPopup('EMAIL', e)}><i className='gusd-mail text-[#667085] text-[20px] xl:text-[1.250vw]'></i>{ unreadMails.current.count ?  <Badge value={unreadMails.current.count}  severity="info"/> : null}</Link> */}
                  <Link to={""} onClick={(e) => openCloseMailPopup('APP', e)}><i className='gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]'>{unreadNotifications.current.count ? <Badge value={unreadNotifications.current.count} severity="info" /> : null}</i></Link>
                  {/* <MailComponent mails={mailData} mailRef={mail}/> */}
                  <NotificationComponent notifications={notificationData} notificationRef={notification} />
                </div>
                <AccountSettings profile={"/initiatorprofile"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=''>
        <div className={sidebarOpen ? 'fixed left-0 top-0 bg-[#113699] py-[20px] xl:py-[1.042vw] px-[12px] xl:px-[0.625vw] w-full max-w-[80px] xl:max-w-[4.167vw] h-full z-20 menu-wrap active' : 'fixed left-0 top-0 bg-[#113699] py-[20px] xl:py-[1.042vw] px-[12px] xl:px-[0.625vw] w-full max-w-[80px] xl:max-w-[4.167vw] h-full z-20 menu-wrap'} onMouseEnter={handleSidebarOpen} onMouseLeave={handleSidebarClose}>
          <ul>
            <li className='logo' data-aos="fade-right" data-aos-duration="500" data-aos-delay="500">
              <Link to={"/all-app-dashboard"}><Image src={logoImg} width={"104"} height={"105"} className='' /></Link>
            </li>
            <li data-aos="fade-right" data-aos-duration="500" data-aos-delay="500">
              <Link to={"/all-app-dashboard"} className={pageProps.activeMenu === "Home" ? "active" : ''} >
                <i className='gusd-home'></i>
                <span>Home</span>
              </Link>
            </li>
			{pageProps.IsSuperadmin == 1 ? <li data-aos="fade-right" data-aos-duration="900" data-aos-delay="500">
              <Link to={pageProps.reDirectUrl ? pageProps.reDirectUrl : ""} className={pageProps.activeMenu === "SuperAdmin" ? "active" : ''}>
                <i className='pi pi-file'></i>
                <span>All Reports</span>
              </Link>
              {/* <Link  
              to={(pageProps?.allFormsUrl)?pageProps.allFormsUrl:"/Initiator/personal_action_form_reportlist/SuperAdminDashboard"}
              
              className={pageProps.activeMenu === "SuperAdmin" ? "active" : ''}>
              <i className='pi pi-file'></i>
              <span>All Forms</span>
              </Link> */}
            </li> : null}
            <li data-aos="fade-right" data-aos-duration="900" data-aos-delay="500">
              <Link to={pageProps.reDirectUrl ? pageProps.reDirectUrl : ""} className={pageProps.activeMenu === "Payroll" ? "active" : ''}>
                <i className='gusd-document'></i>
                <span>Initiate Reports</span>
              </Link>
            </li>
			
			{pageProps.IsArchive ? <li data-aos="fade-right" data-aos-duration="900" data-aos-delay="500">
              <Link to={pageProps.reDirectUrlforArchive ? pageProps.reDirectUrlforArchive : pageProps.reDirectUrl ? pageProps.reDirectUrl : ""} className={pageProps.activeMenu === "Archive" ? "active" : ''}>
                <i className='pi pi-folder'></i>
                <span>Archive Reports</span>
              </Link>
			  </li> : null
			}

            {pageProps.appId === "WEEKLY_ABSENCE_CERTIFIED" || pageProps.appId === "WEEKLY_ABSENCE_CLASSIFIED" || pageProps.appId === "WEEKLY_ABSENCE_REPORT" || pageProps.appId === "WEEKLY_ABSENCE_REPORT_ADMIN" ?
              <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                <Link to={"https://drive.google.com/drive/folders/1SWU9XrnkSXyX-WlhdmSoLbqJgtrMNLNs?usp=drive_link"} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                  <i className='gusd-help'></i>
                  <span>Help</span>
                </Link>
              </li> : ''
            }


            {pageProps.appId === "CLASSIFIED_SUB_REQUEST" ?
              <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                <Link to={"https://drive.google.com/drive/folders/1i9z_P-gD_wXY_SEqIa3T6po5yZfSOD3w?usp=drive_link"} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                  <i className='gusd-help'></i>
                  <span>Help</span>
                </Link>
              </li> : ''
            }

            {pageProps.appId === "SIX_PERIOD" ?
                    <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                      <Link to={"https://drive.google.com/drive/folders/1ZdUUztq4ro2B3qpDAtWAwyHzDWQJuFU9?usp=drive_link"} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                        <i className='gusd-help'></i>
                        <span>Help</span>
                      </Link>
                    </li> : ''
            }
            {pageProps.appId === "TIME_REPORT" ?
              <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                <Link to={"https://drive.google.com/drive/folders/14DWbKwvwy-AFAtY25uthIornWT2cGjv_?usp=sharing"} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                  <i className='gusd-help'></i>
                  <span>Help</span>
                </Link>
              </li> : ''
            }

			{/* {pageProps.appId === "PERSONNEL_ACTION_FORM" ?
              <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                <Link to={"https://drive.google.com/drive/folders/1ZdUUztq4ro2B3qpDAtWAwyHzDWQJuFU9?usp=drive_link"} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                  <i className='gusd-help'></i>
                  <span>Help</span>
                </Link>
              </li>
              : null
            }

            {pageProps.appId === "PERSONAL_SERVICE_AGREEMENT" ?
              <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                <Link to={""} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                  <i className='gusd-help'></i>
                  <span>Help</span>
                </Link>
              </li> : ''
            }
			
			*/}

            {/* {pageProps.appId === "STIPENDS_FORM" ?
              <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                <Link to={"https://drive.google.com/drive/folders/1ZdUUztq4ro2B3qpDAtWAwyHzDWQJuFU9?usp=drive_link"} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                  <i className='gusd-help'></i>
                  <span>Help</span>
                </Link>
              </li> : ''
            } */}

            {pageProps.appId === "SUBSTITUTE_REQUEST_CERTIFICATED" ?
              <li data-aos="fade-right" data-aos-duration="1100" data-aos-delay="500">
                <Link to={"https://drive.google.com/drive/folders/1307ifcoQ9Oc4sK8jp6-QpTsp_YrGuU2U"} className={pageProps.activeMenu === "Help" ? "active" : ''}>
                  <i className='gusd-help'></i>
                  <span>Help</span>
                </Link>
              </li> : ''
            }

          </ul>
        </div>
      </div>
    </div>
    {/* </div> */}
  </>
  )

}
